package com.evoapps.evoshift.ui.courses

import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.widgets.SurfaceCard
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.documents.asPickedFile
import com.evoapps.evoshift.documents.documentDropSpec
import com.evoapps.evoshift.filedrop.DroppedFile
import com.evoapps.evoshift.filedrop.FileDropArea
import com.evoapps.evoshift.filedrop.FileDropTags
import evoshift.composeapp.generated.resources.course_drop_image
import evoshift.composeapp.generated.resources.course_drop_presentation
import evoshift.composeapp.generated.resources.course_drop_presentation_pdf
import org.jetbrains.compose.resources.StringResource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.selection.selectable
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowDownward
import androidx.compose.material.icons.filled.ArrowUpward
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Image
import androidx.compose.material.icons.filled.Notes
import androidx.compose.material.icons.filled.OndemandVideo
import androidx.compose.material.icons.filled.Link
import androidx.compose.material.icons.filled.PictureAsPdf
import androidx.compose.material.icons.filled.Slideshow
import androidx.compose.material.icons.filled.UploadFile
import androidx.compose.material3.Button
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.FilterChip
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.RadioButton
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Switch
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.documents.PickKind
import com.evoapps.evoshift.documents.rememberDocumentPicker
import com.evoapps.evoshift.domain.model.DocumentFiles
import com.evoapps.evoshift.domain.model.PresentationFiles
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.richtext.RichEditorHost
import com.evoapps.evoshift.ui.richtext.RichEditorState
import com.evoapps.evoshift.ui.richtext.RichTextEditor
import com.evoapps.evoshift.ui.richtext.RichToolbar
import com.evoapps.evoshift.ui.richtext.rememberRichEditorHost
import com.evoapps.evoshift.viewmodels.CourseEditorUiState
import com.evoapps.evoshift.domain.model.Course
import com.evoapps.evoshift.domain.model.CourseKind
import com.evoapps.evoshift.domain.model.CoursePage
import com.evoapps.evoshift.domain.model.CoursePageKind
import com.evoapps.evoshift.domain.model.CourseRules
import com.evoapps.evoshift.domain.model.QuizQuestion
import com.evoapps.evoshift.ui.adaptive.ContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.contentWidth
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.ui.util.courseProblemText
import com.evoapps.evoshift.viewmodels.CourseEditorViewModel
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.widgets.DialogWidth
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.rememberStableText
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.course_add_image_page
import evoshift.composeapp.generated.resources.course_add_option
import evoshift.composeapp.generated.resources.course_add_presentation_page
import evoshift.composeapp.generated.resources.course_presentation_link
import evoshift.composeapp.generated.resources.course_presentation_link_hint
import evoshift.composeapp.generated.resources.course_presentation_link_opens
import evoshift.composeapp.generated.resources.course_presentation_link_shown
import evoshift.composeapp.generated.resources.course_presentation_pdf
import evoshift.composeapp.generated.resources.course_presentation_pdf_added
import evoshift.composeapp.generated.resources.course_presentation_pdf_hint
import evoshift.composeapp.generated.resources.course_presentation_remove
import evoshift.composeapp.generated.resources.course_presentation_remove_pdf
import evoshift.composeapp.generated.resources.course_presentation_upload
import evoshift.composeapp.generated.resources.course_presentation_upload_hint
import evoshift.composeapp.generated.resources.course_presentation_uploaded
import evoshift.composeapp.generated.resources.rich_link_address
import evoshift.composeapp.generated.resources.rich_link_apply
import evoshift.composeapp.generated.resources.rich_link_hint
import evoshift.composeapp.generated.resources.rich_link_invalid
import evoshift.composeapp.generated.resources.rich_link_remove
import evoshift.composeapp.generated.resources.rich_link_select
import evoshift.composeapp.generated.resources.rich_link_title
import evoshift.composeapp.generated.resources.course_add_question
import evoshift.composeapp.generated.resources.course_add_text_page
import evoshift.composeapp.generated.resources.course_add_video_page
import evoshift.composeapp.generated.resources.course_all_new_hires
import evoshift.composeapp.generated.resources.course_all_new_hires_hint
import evoshift.composeapp.generated.resources.course_answers_private
import evoshift.composeapp.generated.resources.course_choose_image
import evoshift.composeapp.generated.resources.course_consultation
import evoshift.composeapp.generated.resources.course_counts_for_readiness
import evoshift.composeapp.generated.resources.course_counts_for_readiness_hint
import evoshift.composeapp.generated.resources.course_delete
import evoshift.composeapp.generated.resources.course_delete_confirm
import evoshift.composeapp.generated.resources.course_description
import evoshift.composeapp.generated.resources.course_due_days
import evoshift.composeapp.generated.resources.course_edit_title
import evoshift.composeapp.generated.resources.course_for_roles
import evoshift.composeapp.generated.resources.course_image_added
import evoshift.composeapp.generated.resources.course_image_caption
import evoshift.composeapp.generated.resources.course_instructor
import evoshift.composeapp.generated.resources.course_kind
import evoshift.composeapp.generated.resources.course_lesson_hours
import evoshift.composeapp.generated.resources.course_lesson_hours_hint
import evoshift.composeapp.generated.resources.course_move_down
import evoshift.composeapp.generated.resources.course_move_up
import evoshift.composeapp.generated.resources.course_multi
import evoshift.composeapp.generated.resources.course_new_title
import evoshift.composeapp.generated.resources.course_ohs_details
import evoshift.composeapp.generated.resources.course_option
import evoshift.composeapp.generated.resources.course_page_body
import evoshift.composeapp.generated.resources.course_page_number
import evoshift.composeapp.generated.resources.course_page_title
import evoshift.composeapp.generated.resources.course_pages
import evoshift.composeapp.generated.resources.course_pass_percent
import evoshift.composeapp.generated.resources.course_publish
import evoshift.composeapp.generated.resources.course_publish_changes
import evoshift.composeapp.generated.resources.course_question
import evoshift.composeapp.generated.resources.course_question_number
import evoshift.composeapp.generated.resources.course_quiz
import evoshift.composeapp.generated.resources.course_quiz_hint
import evoshift.composeapp.generated.resources.course_remove_option
import evoshift.composeapp.generated.resources.course_remove_page
import evoshift.composeapp.generated.resources.course_remove_question
import evoshift.composeapp.generated.resources.course_right_answer
import evoshift.composeapp.generated.resources.course_save_draft
import evoshift.composeapp.generated.resources.course_title_field
import evoshift.composeapp.generated.resources.course_video_privacy
import evoshift.composeapp.generated.resources.course_video_url
import evoshift.composeapp.generated.resources.course_who
import evoshift.composeapp.generated.resources.delete
import org.jetbrains.compose.resources.stringResource

private val ProblemColor = Color(0xFFB3261E)

/** The "right answer" box of option [option] of question [question] (0-based). */
fun rightAnswerTag(question: Int, option: Int) = "right_answer_${question}_$option"

/**
 * SH-126: writing a course (managers): title, kind (an OHS kind shows what the regulation asks for),
 * pages (text, picture, video link with its privacy note), the quiz with its right answers (kept
 * apart, for managers only), who takes it by when. Save as a draft or publish; a published course
 * changes only by publishing again (a new version).
 */
@Composable
fun CourseEditorScreen(viewModel: CourseEditorViewModel, onNavigateBack: () -> Unit) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val snackbarHostState = remember { SnackbarHostState() }
    val shown = (state.error ?: state.message)?.asString()
    LaunchedEffect(shown) {
        shown?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.messageShown()
        }
    }
    LaunchedEffect(state.done) { if (state.done) onNavigateBack() }
    // What the open chooser is for: a page's picture, its presentation or the presentation's PDF.
    var pickFor by remember { mutableStateOf<Pair<String, PickKind>?>(null) }
    var pickImage by remember { mutableStateOf(false) }
    val picker = rememberDocumentPicker { file ->
        val (pageId, kind) = pickFor ?: return@rememberDocumentPicker
        when {
            pickImage -> viewModel.onImagePicked(pageId, file)
            else -> viewModel.onPresentationPicked(pageId, file, pdfOnly = kind == PickKind.PDF)
        }
    }
    var deleting by remember { mutableStateOf(false) }
    // SH-211: the lesson editors; on a phone their toolbar sits above the keyboard.
    val editors = rememberRichEditorHost()
    val compact = LocalWindowWidthClass.current.isCompact

    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        topBar = { EvoTopBar(title = stringResource(if (state.isNew) Res.string.course_new_title else Res.string.course_edit_title), onBack = onNavigateBack) },
        bottomBar = {
            val active = editors.active
            if (compact && active != null) {
                RichToolbar(active, editors, Modifier.imePadding().navigationBarsPadding().padding(horizontal = 8.dp, vertical = 4.dp))
            }
        }
    ) { padding ->
        Box(Modifier.padding(padding).fillMaxSize().contentWidth(ContentMaxWidth)) {
            val course = state.course
            if (state.isLoading || course == null) {
                if (state.isLoading) CircularProgressIndicator(Modifier.align(Alignment.Center))
                return@Box
            }
            Column(
                modifier = Modifier.fillMaxWidth().verticalScroll(rememberScrollState()).padding(16.dp),
                verticalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                StableOutlinedField(
                    value = course.title, onValueChange = viewModel::setTitle,
                    label = { Text(stringResource(Res.string.course_title_field)) }, singleLine = true, modifier = Modifier.fillMaxWidth()
                )
                StableOutlinedField(
                    value = course.description, onValueChange = viewModel::setDescription,
                    label = { Text(stringResource(Res.string.course_description)) }, minLines = 2, modifier = Modifier.fillMaxWidth()
                )
                KindSection(course, viewModel)
                PagesSection(
                    course, state, viewModel, editors, inlineToolbar = !compact,
                    onPick = { pageId, kind -> pickImage = kind == PickKind.DOCUMENT; pickFor = pageId to kind; picker.pick(kind) },
                    onDrop = { pageId, kind, file ->
                        if (kind == PickKind.DOCUMENT) viewModel.onImagePicked(pageId, file.asPickedFile())
                        else viewModel.onPresentationPicked(pageId, file.asPickedFile(), pdfOnly = kind == PickKind.PDF)
                    }
                )
                QuizSection(course, state.correct, viewModel)
                WhoSection(course, state.roles, viewModel)
                state.problems.sortedBy { it.ordinal }.forEach { problem ->
                    Text(courseProblemText(problem).asString(), color = ProblemColor, style = MaterialTheme.typography.bodySmall)
                }
                Row(horizontalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.align(Alignment.End)) {
                    TextButton(onClick = { deleting = true }, enabled = !state.isSaving) { Text(stringResource(Res.string.course_delete)) }
                    if (!course.isPublished) {
                        OutlinedButton(onClick = viewModel::saveDraft, enabled = !state.isSaving) { Text(stringResource(Res.string.course_save_draft)) }
                    }
                    Button(onClick = viewModel::publish, enabled = !state.isSaving) {
                        Text(stringResource(if (course.isPublished) Res.string.course_publish_changes else Res.string.course_publish))
                    }
                }
            }
        }
    }

    editors.linking?.let { editing -> LinkDialog(editing, editors) }

    if (deleting) {
        EvoDialog(
            title = stringResource(Res.string.course_delete),
            icon = Icons.Default.Delete,
            onDismiss = { deleting = false },
            destructive = true,
            width = DialogWidth.Compact,
            confirm = DialogAction(stringResource(Res.string.delete), { deleting = false; viewModel.delete() }, destructive = true)
        ) {
            Text(stringResource(Res.string.course_delete_confirm, state.course?.title.orEmpty()), color = Color.White.copy(alpha = 0.85f))
        }
    }
}

@Composable
private fun EditorSection(title: String, content: @Composable () -> Unit) {
    SurfaceCard(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            Text(title, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
            content()
        }
    }
}

@Composable
private fun KindSection(course: Course, viewModel: CourseEditorViewModel) {
    EditorSection(stringResource(Res.string.course_kind)) {
        CourseKind.entries.forEach { kind ->
            Row(
                Modifier.fillMaxWidth().selectable(selected = course.kind == kind, onClick = { viewModel.setKind(kind) }, role = Role.RadioButton),
                verticalAlignment = Alignment.Top
            ) {
                RadioButton(selected = course.kind == kind, onClick = null)
                Spacer(Modifier.width(8.dp))
                Column {
                    Text(stringResource(kind.label()), fontWeight = FontWeight.Bold)
                    Text(stringResource(kind.hint()), style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                }
            }
        }
        val ohs = course.ohs
        if (course.kind.isOhs && ohs != null) {
            Text(stringResource(Res.string.course_ohs_details), fontWeight = FontWeight.Bold, modifier = Modifier.padding(top = 8.dp))
            StableOutlinedField(
                value = if (ohs.lessonHours == 0) "" else ohs.lessonHours.toString(), onValueChange = viewModel::setLessonHours,
                label = { Text(stringResource(Res.string.course_lesson_hours)) },
                supportingText = { Text(stringResource(Res.string.course_lesson_hours_hint, CourseRules.minLessonHours(course.kind))) },
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number), singleLine = true, modifier = Modifier.fillMaxWidth()
            )
            StableOutlinedField(
                value = ohs.instructorName, onValueChange = viewModel::setInstructor,
                label = { Text(stringResource(Res.string.course_instructor)) }, singleLine = true, modifier = Modifier.fillMaxWidth()
            )
            StableOutlinedField(
                value = ohs.consultation, onValueChange = viewModel::setConsultation,
                label = { Text(stringResource(Res.string.course_consultation)) }, singleLine = true, modifier = Modifier.fillMaxWidth()
            )
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun PagesSection(
    course: Course,
    state: CourseEditorUiState,
    viewModel: CourseEditorViewModel,
    editors: RichEditorHost,
    inlineToolbar: Boolean,
    onPick: (String, PickKind) -> Unit,
    onDrop: (String, PickKind, DroppedFile?) -> Unit
) {
    EditorSection(stringResource(Res.string.course_pages)) {
        course.pages.forEachIndexed { index, page ->
            key(page.id) {
                // SH-233: a picture or presentation dropped on its page (web, desktop) goes the chooser's way.
                val dropKind = page.dropKind()
                FileDropArea(
                    spec = documentDropSpec(dropKind ?: PickKind.DOCUMENT),
                    dropLabel = stringResource(dropLabel(dropKind)),
                    onFile = { file -> dropKind?.let { onDrop(page.id, it, file) } },
                    enabled = dropKind != null && state.uploadingPageId != page.id,
                    tag = FileDropTags.coursePage(page.id)
                ) {
                    PageEditor(index, page, course.pages.size, state, viewModel, editors, inlineToolbar, onPick)
                }
            }
        }
        if (course.pages.size < CourseRules.MAX_PAGES) {
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                OutlinedButton(onClick = { viewModel.addPage(CoursePageKind.TEXT) }) {
                    Icon(Icons.Default.Notes, contentDescription = null); Spacer(Modifier.width(4.dp)); Text(stringResource(Res.string.course_add_text_page))
                }
                OutlinedButton(onClick = { viewModel.addPage(CoursePageKind.IMAGE) }) {
                    Icon(Icons.Default.Image, contentDescription = null); Spacer(Modifier.width(4.dp)); Text(stringResource(Res.string.course_add_image_page))
                }
                OutlinedButton(onClick = { viewModel.addPage(CoursePageKind.VIDEO_LINK) }) {
                    Icon(Icons.Default.OndemandVideo, contentDescription = null); Spacer(Modifier.width(4.dp)); Text(stringResource(Res.string.course_add_video_page))
                }
                OutlinedButton(onClick = { viewModel.addPage(CoursePageKind.PRESENTATION) }) {
                    Icon(Icons.Default.Slideshow, contentDescription = null); Spacer(Modifier.width(4.dp)); Text(stringResource(Res.string.course_add_presentation_page))
                }
            }
        }
    }
}

/**
 * SH-211: a page's formatted text: the toolbar above the field on wide screens (on phones the
 * screen's bottom bar has it, above the keyboard).
 */
@Composable
private fun RichPageBody(page: CoursePage, label: String, minLines: Int, viewModel: CourseEditorViewModel, editors: RichEditorHost, inlineToolbar: Boolean) {
    val editor = remember(page.id) { RichEditorState(page.document) { viewModel.setPageRich(page.id, it) } }
    Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
        if (inlineToolbar) RichToolbar(editor, editors)
        RichTextEditor(editor, editors, label, Modifier.fillMaxWidth(), minLines = minLines)
    }
}

@Composable
private fun PageEditor(
    index: Int,
    page: CoursePage,
    count: Int,
    state: CourseEditorUiState,
    viewModel: CourseEditorViewModel,
    editors: RichEditorHost,
    inlineToolbar: Boolean,
    onPick: (String, PickKind) -> Unit
) {
    val uploading = state.uploadingPageId == page.id
    Column(Modifier.fillMaxWidth().padding(vertical = 4.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Text(
                stringResource(Res.string.course_page_number, index + 1) + " · " + stringResource(page.kind.label()),
                fontWeight = FontWeight.Bold, modifier = Modifier.weight(1f)
            )
            IconButtonWithTooltip(onClick = { viewModel.movePage(page.id, -1) }, enabled = index > 0, modifier = Modifier.size(36.dp), tooltip = stringResource(Res.string.course_move_up)) {
                Icon(Icons.Default.ArrowUpward, contentDescription = stringResource(Res.string.course_move_up))
            }
            IconButtonWithTooltip(onClick = { viewModel.movePage(page.id, 1) }, enabled = index < count - 1, modifier = Modifier.size(36.dp), tooltip = stringResource(Res.string.course_move_down)) {
                Icon(Icons.Default.ArrowDownward, contentDescription = stringResource(Res.string.course_move_down))
            }
            IconButtonWithTooltip(onClick = { viewModel.removePage(page.id) }, modifier = Modifier.size(36.dp), tooltip = stringResource(Res.string.course_remove_page)) {
                Icon(Icons.Default.Delete, contentDescription = stringResource(Res.string.course_remove_page))
            }
        }
        StableOutlinedField(
            value = page.title, onValueChange = { viewModel.setPageTitle(page.id, it) },
            label = { Text(stringResource(Res.string.course_page_title)) }, singleLine = true, modifier = Modifier.fillMaxWidth()
        )
        when (page.kind) {
            CoursePageKind.TEXT -> RichPageBody(page, stringResource(Res.string.course_page_body), 4, viewModel, editors, inlineToolbar)
            CoursePageKind.IMAGE -> {
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    OutlinedButton(onClick = { onPick(page.id, PickKind.DOCUMENT) }, enabled = !uploading) { Text(stringResource(Res.string.course_choose_image)) }
                    if (uploading) CircularProgressIndicator(Modifier.size(20.dp), strokeWidth = 2.dp)
                    else if (page.imagePath != null) Text(stringResource(Res.string.course_image_added), color = TrainingDoneColor)
                }
                StableOutlinedField(
                    value = page.body, onValueChange = { viewModel.setPageBody(page.id, it) },
                    label = { Text(stringResource(Res.string.course_image_caption)) }, modifier = Modifier.fillMaxWidth()
                )
            }
            CoursePageKind.VIDEO_LINK -> {
                StableOutlinedField(
                    value = page.url.orEmpty(), onValueChange = { viewModel.setPageUrl(page.id, it) },
                    label = { Text(stringResource(Res.string.course_video_url)) }, singleLine = true,
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Uri), modifier = Modifier.fillMaxWidth()
                )
                Text(stringResource(Res.string.course_video_privacy), style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
                RichPageBody(page, stringResource(Res.string.course_page_body), 2, viewModel, editors, inlineToolbar)
            }
            CoursePageKind.PRESENTATION -> {
                PresentationEditor(page, state, uploading, viewModel, onPick)
                RichPageBody(page, stringResource(Res.string.course_page_body), 2, viewModel, editors, inlineToolbar)
            }
        }
    }
}

/**
 * SH-233: what a file dropped on this page is, as its picker button would choose it: a picture
 * page's picture, a presentation page's file (or, once a .pptx / .odp is uploaded, its PDF
 * export); null where the page takes no file (text, video, a presentation already complete).
 */
internal fun CoursePage.dropKind(): PickKind? = when (kind) {
    CoursePageKind.IMAGE -> PickKind.DOCUMENT
    CoursePageKind.PRESENTATION -> {
        val uploaded = presentation?.takeIf { it.isUpload }
        when {
            uploaded == null -> PickKind.PRESENTATION
            uploaded.fileType != DocumentFiles.PDF && uploaded.pdfPath == null -> PickKind.PDF
            else -> null
        }
    }
    else -> null
}

/** The highlight's words for a drop of [kind] on a course page. */
private fun dropLabel(kind: PickKind?): StringResource = when (kind) {
    PickKind.PRESENTATION -> Res.string.course_drop_presentation
    PickKind.PDF -> Res.string.course_drop_presentation_pdf
    else -> Res.string.course_drop_image
}

/**
 * SH-211: a presentation page's link (normalised to the provider's embed address, with why a
 * link is not accepted) or its uploaded file, and for a .pptx / .odp the PDF export learners see
 * inside the course on the web.
 */
@Composable
private fun PresentationEditor(page: CoursePage, state: CourseEditorUiState, uploading: Boolean, viewModel: CourseEditorViewModel, onPick: (String, PickKind) -> Unit) {
    val presentation = page.presentation
    val hint = MaterialTheme.colorScheme.onSurfaceVariant
    val mb = PresentationFiles.MAX_BYTES / (1024 * 1024)
    if (presentation?.isUpload == true) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Icon(Icons.Default.Slideshow, contentDescription = null, tint = TrainingDoneColor)
            Spacer(Modifier.width(8.dp))
            Text(stringResource(Res.string.course_presentation_uploaded, presentation.fileName.orEmpty()), modifier = Modifier.weight(1f))
            TextButton(onClick = { viewModel.removePresentation(page.id) }, enabled = !uploading) { Text(stringResource(Res.string.course_presentation_remove)) }
        }
        if (presentation.fileType != DocumentFiles.PDF) {
            if (presentation.pdfPath == null) {
                OutlinedButton(onClick = { onPick(page.id, PickKind.PDF) }, enabled = !uploading) {
                    Icon(Icons.Default.PictureAsPdf, contentDescription = null); Spacer(Modifier.width(4.dp)); Text(stringResource(Res.string.course_presentation_pdf))
                }
            } else {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Default.PictureAsPdf, contentDescription = null, tint = TrainingDoneColor)
                    Spacer(Modifier.width(8.dp))
                    Text(stringResource(Res.string.course_presentation_pdf_added, presentation.pdfName.orEmpty()), modifier = Modifier.weight(1f))
                    TextButton(onClick = { viewModel.removePresentation(page.id, pdfOnly = true) }, enabled = !uploading) { Text(stringResource(Res.string.course_presentation_remove_pdf)) }
                }
            }
            Text(stringResource(Res.string.course_presentation_pdf_hint), style = MaterialTheme.typography.bodySmall, color = hint)
        }
        if (uploading) CircularProgressIndicator(Modifier.size(20.dp), strokeWidth = 2.dp)
        return
    }
    val problem = state.linkProblems[page.id]
    StableOutlinedField(
        value = state.presentationLinks[page.id] ?: presentation?.link.orEmpty(),
        onValueChange = { viewModel.setPresentationLink(page.id, it) },
        label = { Text(stringResource(Res.string.course_presentation_link)) },
        singleLine = true,
        isError = problem != null,
        supportingText = {
            Text(
                when {
                    problem != null -> stringResource(problem.label())
                    presentation != null && presentation.embedUrl == null -> stringResource(Res.string.course_presentation_link_opens, stringResource(presentation.source.label()))
                    presentation != null -> stringResource(Res.string.course_presentation_link_shown, stringResource(presentation.source.label()))
                    else -> stringResource(Res.string.course_presentation_link_hint)
                }
            )
        },
        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Uri),
        modifier = Modifier.fillMaxWidth()
    )
    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        OutlinedButton(onClick = { onPick(page.id, PickKind.PRESENTATION) }, enabled = !uploading) {
            Icon(Icons.Default.UploadFile, contentDescription = null); Spacer(Modifier.width(4.dp)); Text(stringResource(Res.string.course_presentation_upload))
        }
        if (uploading) CircularProgressIndicator(Modifier.size(20.dp), strokeWidth = 2.dp)
    }
    Text(stringResource(Res.string.course_presentation_upload_hint, mb), style = MaterialTheme.typography.bodySmall, color = hint)
}

/** SH-211: the address of the selected text's link (http, https or mailto only). */
@Composable
private fun LinkDialog(editor: RichEditorState, editors: RichEditorHost) {
    val existing = editor.currentLink()
    var address by remember(editor) { mutableStateOf(existing.orEmpty()) }
    var invalid by remember(editor) { mutableStateOf(false) }
    val canLink = !editor.value.selection.collapsed || existing != null
    val close = { editors.linking = null; editors.refocus(editor) }
    EvoDialog(
        title = stringResource(Res.string.rich_link_title),
        icon = Icons.Default.Link,
        onDismiss = close,
        width = DialogWidth.Compact,
        confirm = DialogAction(
            stringResource(Res.string.rich_link_apply),
            { if (editor.setLink(address)) close() else invalid = true },
            enabled = canLink && address.isNotBlank()
        ),
        neutral = existing?.let { DialogAction(stringResource(Res.string.rich_link_remove), { editor.setLink(null); close() }) }
    ) {
        if (!canLink) Text(stringResource(Res.string.rich_link_select))
        OutlinedTextField(
            value = address,
            onValueChange = { address = it; invalid = false },
            label = { Text(stringResource(Res.string.rich_link_address)) },
            singleLine = true,
            isError = invalid,
            supportingText = { Text(stringResource(if (invalid) Res.string.rich_link_invalid else Res.string.rich_link_hint)) },
            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Uri),
            modifier = Modifier.fillMaxWidth()
        )
    }
}

@Composable
private fun QuizSection(course: Course, correct: Map<String, List<Int>>, viewModel: CourseEditorViewModel) {
    EditorSection(stringResource(Res.string.course_quiz)) {
        Text(stringResource(Res.string.course_quiz_hint), style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
        StableOutlinedField(
            value = if (course.passPercent == 0) "" else course.passPercent.toString(), onValueChange = viewModel::setPassPercent,
            label = { Text(stringResource(Res.string.course_pass_percent)) }, suffix = { Text("%") },
            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number), singleLine = true, modifier = Modifier.fillMaxWidth()
        )
        course.questions.forEachIndexed { index, question -> QuestionEditor(index, question, correct[question.id].orEmpty(), viewModel) }
        if (course.questions.size < CourseRules.MAX_QUESTIONS) {
            OutlinedButton(onClick = viewModel::addQuestion) { Text(stringResource(Res.string.course_add_question)) }
        }
        Text(stringResource(Res.string.course_answers_private), style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
    }
}

@Composable
private fun QuestionEditor(index: Int, question: QuizQuestion, right: List<Int>, viewModel: CourseEditorViewModel) {
    Column(Modifier.fillMaxWidth().padding(vertical = 4.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Text(stringResource(Res.string.course_question_number, index + 1), fontWeight = FontWeight.Bold, modifier = Modifier.weight(1f))
            IconButtonWithTooltip(onClick = { viewModel.removeQuestion(question.id) }, modifier = Modifier.size(36.dp), tooltip = stringResource(Res.string.course_remove_question)) {
                Icon(Icons.Default.Delete, contentDescription = stringResource(Res.string.course_remove_question))
            }
        }
        StableOutlinedField(
            value = question.text, onValueChange = { viewModel.setQuestionText(question.id, it) },
            label = { Text(stringResource(Res.string.course_question)) }, modifier = Modifier.fillMaxWidth()
        )
        Row(verticalAlignment = Alignment.CenterVertically) {
            Text(stringResource(Res.string.course_multi), modifier = Modifier.weight(1f))
            Switch(checked = question.multi, onCheckedChange = { viewModel.setMulti(question.id, it) })
        }
        question.options.forEachIndexed { optionIndex, option ->
            Row(verticalAlignment = Alignment.CenterVertically) {
                Checkbox(
                    checked = optionIndex in right,
                    onCheckedChange = { viewModel.toggleCorrect(question.id, optionIndex) },
                    modifier = Modifier.testTag(rightAnswerTag(index, optionIndex))
                )
                StableOutlinedField(
                    value = option, onValueChange = { viewModel.setOption(question.id, optionIndex, it) },
                    label = { Text(stringResource(Res.string.course_option, optionIndex + 1)) }, singleLine = true, modifier = Modifier.weight(1f)
                )
                if (question.options.size > CourseRules.MIN_OPTIONS) {
                    IconButtonWithTooltip(onClick = { viewModel.removeOption(question.id, optionIndex) }, modifier = Modifier.size(36.dp), tooltip = stringResource(Res.string.course_remove_option)) {
                        Icon(Icons.Default.Close, contentDescription = stringResource(Res.string.course_remove_option))
                    }
                }
            }
        }
        Text(stringResource(Res.string.course_right_answer), style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
        if (question.options.size < CourseRules.MAX_OPTIONS) {
            TextButton(onClick = { viewModel.addOption(question.id) }) { Text(stringResource(Res.string.course_add_option)) }
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun WhoSection(course: Course, roles: List<String>, viewModel: CourseEditorViewModel) {
    EditorSection(stringResource(Res.string.course_who)) {
        if (roles.isNotEmpty()) {
            Text(stringResource(Res.string.course_for_roles))
            FlowRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                roles.forEach { role ->
                    FilterChip(selected = role in course.roles, onClick = { viewModel.toggleRole(role) }, label = { Text(role) })
                }
            }
        }
        Row(verticalAlignment = Alignment.CenterVertically) {
            Column(Modifier.weight(1f)) {
                Text(stringResource(Res.string.course_all_new_hires))
                Text(stringResource(Res.string.course_all_new_hires_hint), style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
            }
            Switch(checked = course.allNewHires, onCheckedChange = viewModel::setAllNewHires)
        }
        StableOutlinedField(
            value = course.dueDays.toString(), onValueChange = viewModel::setDueDays,
            label = { Text(stringResource(Res.string.course_due_days)) },
            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number), singleLine = true, modifier = Modifier.fillMaxWidth()
        )
        Row(verticalAlignment = Alignment.CenterVertically) {
            Column(Modifier.weight(1f)) {
                Text(stringResource(Res.string.course_counts_for_readiness))
                Text(stringResource(Res.string.course_counts_for_readiness_hint), style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
            }
            Switch(checked = course.countsForReadiness, onCheckedChange = viewModel::setCountsForReadiness, enabled = !course.kind.isOhs)
        }
    }
}

/**
 * The editor's text field: [rememberStableText] keeps the caret and the typed text while the view
 * model echoes each edit (iOS jumped the cursor otherwise).
 */
@Composable
private fun StableOutlinedField(
    value: String,
    onValueChange: (String) -> Unit,
    label: @Composable () -> Unit,
    modifier: Modifier = Modifier,
    supportingText: @Composable (() -> Unit)? = null,
    suffix: @Composable (() -> Unit)? = null,
    keyboardOptions: KeyboardOptions = KeyboardOptions.Default,
    singleLine: Boolean = false,
    minLines: Int = 1,
    isError: Boolean = false
) {
    rememberStableText(value, onValueChange).let { stable ->
        OutlinedTextField(
            value = stable.value,
            onValueChange = stable.onValueChange,
            label = label,
            modifier = modifier,
            supportingText = supportingText,
            suffix = suffix,
            keyboardOptions = keyboardOptions,
            singleLine = singleLine,
            minLines = minLines,
            isError = isError
        )
    }
}
